export { default as Tooltip } from "./tooltip";
export type { TooltipProps } from "./tooltip";
